import { FaBuilding, FaUserCheck, FaHardHat, FaMapMarkerAlt } from 'react-icons/fa';

const counter = [
    {
        id: 1,
        icon: <FaBuilding />, // Building icon
        title: 'Projects Completed',
        count: '5000',
    },
    {
        id: 2,
        icon: <FaUserCheck />, // User check icon
        title: 'Satisfied Clients',
        count: '10000',
    },
    {
        id: 3,
        icon: <FaHardHat />, // Hard hat icon
        title: 'Years of Expertise',
        count: '15',
    },
    {
        id: 4,
        icon: <FaMapMarkerAlt />, // Map marker icon
        title: 'Cities Served',
        count: '50',
    },
];

export default counter;